import type { JSX } from 'react';
import { useI18n } from '../../../i18n';
import { requestApplyHint } from '../../../lib/aiBridge';
import { useRemarks } from '../../../hooks/useRemarks';
import { fill } from './remarkText';
import { Button } from '../../ui/button';

/**
 * «Тиа: … — отметить?» under an objective at the table (mockup .inline-guess): the ONE newest hint from the game that
 * is not out of date; «Mark» asks the server (the card with its undo lands in the chat), «No» leaves it.
 */
export function ObjectiveGameHint({ questId, objectiveId }: { readonly questId: string; readonly objectiveId: string }): JSX.Element | null {
  const { t } = useI18n();
  const { tableHint, dismiss } = useRemarks();
  if (tableHint === undefined || tableHint.questId !== questId || tableHint.objectiveId !== objectiveId) return null;
  return (
    <div
      data-testid="ai-game-hint"
      className="col-start-2 mt-1 flex flex-wrap items-center gap-1.5 rounded border border-dashed border-ai/50 px-2 py-1 text-ui"
    >
      <span className="text-ai">{fill(t('remarks.hint.line'), { reason: tableHint.title })}</span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={(): void => {
          // The toast comes with the server's card (useAiChat), not with the click.
          requestApplyHint({ key: tableHint.key, title: tableHint.title });
        }}
      >
        {t('remarks.mark')}
      </Button>
      <button type="button" className="px-0.5 text-ui text-hl hover:underline" onClick={(): void => dismiss(tableHint.key)}>
        {t('remarks.no')}
      </button>
    </div>
  );
}
